import { DateRange } from "components/form_components/Inputs";
import { BidFilterContentProps, StyledFilterContent } from "./utils";

function CreatedDateFilterContent({ control }: BidFilterContentProps) {
  return (
    <StyledFilterContent aria-label="Created date filter">
      <DateRange name="createdDate.filter" control={control} label="" />
    </StyledFilterContent>
  );
}

export default CreatedDateFilterContent;
